import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: end;
  gap: 1rem;
  margin-top: 2rem;

  > button {
    margin: 0;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    justify-content: center;

    > button {
      width: 100%;
      margin: 0;
      display: block;
      max-width: 100% !important;
    }
  }
`;

